import React from 'react';
import SectionHeader from '@/components/SectionHeader';
import { ModalType } from '@/store/modal';
import { Box, Flex } from '@legion-ui/core';
import UserRoleCard from '@/components/UserRoleCard';
import { UsersType } from '@/@types/user.types';
import { usePublisherInputStore } from '@/store/police/publisher.input';
import { useAdminInputStore } from '@/store/police/admin.input';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface UserRoleProps {
  user?: UsersType;
  toggleModal: (type: ModalType) => void;
  isLoading?: boolean;
}

const UserRoleSection: React.FC<UserRoleProps> = ({ user, toggleModal, isLoading = false }) => {
  const adminStore = useAdminInputStore((state) => state);
  const publisherStore = usePublisherInputStore((state) => state);
  // Skeleton loading state
  if (isLoading) {
    return (
      <div className="mb-6">
        <Skeleton height={24} width={100} className="mb-3" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[...Array(2)].map((_, i) => (
            <div key={i}>
              <Skeleton height={20} width={80} className="mb-2" />
              <Skeleton height={40} />
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  return (
    <Box mb="1.5rem">
      <SectionHeader
        title="Role"
        toggleModal={toggleModal}
      />
      <Flex className="flex flex-col items-center w-full gap-4 sm:flex-row sm:items-start">

        {/* Will Be Displayed By Add Role */}
        <UserRoleCard
          title="Publisher"
          description="Publisher is a user role who can publish and manage APIs in Publisher Portal"
          status={
            publisherStore.userAllowed ?? user?.isPublisher ? 'Allowed' : 'Prohibited'
          }
          modalType={ModalType.Publisher}
          toggleModal={toggleModal}
        />
        <UserRoleCard
          title="Admin"
          description="Admin is a user role who can access and manage information related to Apilogy users"
          status={
            adminStore.userAllowed ?? user?.isAdmin ? 'Allowed' : 'Prohibited'
          }
          modalType={ModalType.Admin}
          toggleModal={toggleModal}
        />
        
      </Flex>
    </Box>
  );
};

export default UserRoleSection;

